import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectContainedWork } from 'app/selectors/catalogBibs/CatalogBibSelector';
import Contains from './Contains';

export class ContainsContainer extends React.PureComponent {
  render() {
    return this.props.containedWork && <Contains {...this.props} />;
  }
}

ContainsContainer.propTypes = {
  containedWork: ImmutablePropTypes.listOf(ImmutablePropTypes.map)
};

const mapStateToProps = state => ({ containedWork: selectContainedWork(state) });

export default connect(mapStateToProps)(ContainsContainer);
